var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBlue01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407 413",
    style: {
      enableBackground: "new 0 0 407 413"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00266C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.7,210.7c-1.6-1.6-2.5-3.8-2.5-6c0-2.3,0.9-4.4,2.5-6L361.5,85.3c0.9-0.9,1-2,1-2.5s-0.1-1.6-1.1-2.6 l-32.6-32.8c-0.7-0.7-1.5-1-2.5-1c-0.9,0-1.9,0.4-2.5,1L209.5,160.5c-1.7,1.6-3.8,2.5-6,2.5s-4.3-0.8-6-2.5L83.2,47.5 c-0.7-0.7-1.5-1-2.5-1c-0.9,0-1.9,0.4-2.5,1L45.5,80.3c-0.9,0.9-1,2-1,2.5c0,0.6,0.1,1.6,1,2.5l114.7,113.4c1.6,1.6,2.5,3.8,2.5,6 s-0.9,4.4-2.5,6L45.9,325.6c-0.5,0.5-1.1,1.4-1.1,2.5c0,0.5,0.1,1.6,0.8,2.2c0.1,0.1,0.2,0.2,0.3,0.3l32.6,32.8 c0.7,0.7,1.6,1.1,2.5,1.1c1,0,1.7-0.3,2.2-0.9c0.1-0.1,0.2-0.2,0.2-0.2l113.9-114.5c1.6-1.6,3.8-2.5,6-2.5c0,0,0,0,0,0 c2.3,0,4.4,0.9,6,2.5l114,114.4c0.7,0.7,1.6,1.1,2.5,1.1c1,0,1.7-0.3,2.2-0.9c0.1-0.1,0.1-0.2,0.2-0.2l32.6-32.8 c0.5-0.5,1.1-1.3,1.1-2.5c0-0.2,0-0.4,0-0.5c0-0.5-0.3-1.2-0.9-1.9L246.7,210.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlue01);
export default __webpack_public_path__ + "static/media/close-blue-01.907e97c8b11a3ea089b3c7fc266134ba.svg";
export { ForwardRef as ReactComponent };